import { usePermissions } from 'permissions';
import { Card, Col, InfinityLoading, Row, withErrorBoundary } from 'ui';
import { ProgramLayout } from '../program-layout';
import { ProgramTopPanel } from '../program-top-panel';
import { useProgramTimelineFeed } from './hooks';
import { ProgramTopicsList } from './program-topics-list';
import { TimelineItemContent } from './timeline-item-content';

type P = {
  programId: string;
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramTimeline = ({ programId }: P) => {
  const { canCreateProgramContent } = usePermissions();
  const { collection, fetchNextPage, hasNextPage, isFetching, isLoading, item, onSelectPost, onSelectTopic } =
    useProgramTimelineFeed({
      programId,
    });

  return (
    <ProgramLayout programId={programId}>
      {(program) => (
        <Row gutter="ms">
          <Col span={10}>
            <Card className="program__background" shrinkedLeft shrinkedRight shrinkedTop>
              <ProgramTopicsList
                items={collection}
                loading={isLoading}
                onSelectPost={onSelectPost}
                onSelectTopic={onSelectTopic}
                program={program}
                topics={program.topics}
              />
              <InfinityLoading hasMoreData={hasNextPage} isLoading={isFetching} onEnter={fetchNextPage} />
            </Card>
          </Col>
          <Col span={14}>
            {canCreateProgramContent({ program }) ? <ProgramTopPanel program={program} programId={program.id} /> : null}
            <Card className="timeline-content-card">
              <TimelineItemContent isLoading={isLoading} item={item} program={program} />
            </Card>
          </Col>
        </Row>
      )}
    </ProgramLayout>
  );
};

export default withErrorBoundary(ProgramTimeline);
